<template>
  <div class="hint_icon_wrapper" @mouseenter="showHint = true" @mouseleave="showHint = false">
    <svg viewBox="0 0 24 24" class="icon_svg">
      <circle cx="12" cy="12" r="10" :stroke="circleStroke || 'currentColor'" stroke-width="2" :fill="circleFill || 'none'" />
      <circle cx="12" cy="16.5" r="1.2" :fill="textFill || 'currentColor'" />
      <path d="M12 13.5V12.5C12 11.5 12.5 11 13.5 10.5C14.5 10 15 9.10457 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8" :stroke="textFill || 'currentColor'" stroke-width="2" stroke-linecap="round" fill="none" />
    </svg>

    <div class="hint_tooltip">
      <div class="tooltip_content">
        {{ $t('hint_tooltip') }}
      </div>
      <div class="tooltip_arrow"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const showHint = ref(false)
interface Props {
  circleFill?: string
  circleStroke?: string
  textFill?: string
}

withDefaults(defineProps<Props>(), {
  circleFill: 'transparent',
  circleStroke: 'rgba(0,0,0,0.2)',
  textFill: 'rgba(0,0,0,0.4)',
})
</script>

<style lang="less" scoped>
.hint_icon_wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px; /* 初始尺寸极大缩小，看起来像个精致的标记点 */
  height: 14px;
  transition: all 0.4s var(--transition-base);

  .icon_svg {
    width: 100%;
    height: 100%;
    opacity: 0.65; /* 初始几乎半透明，极简 */
    filter: grayscale(1);
    transform: scale(0.8); /* 初始态更紧凑 */
    transition: all 0.4s var(--transition-base);
  }

  &:hover {
    transform: scale(1.4); /* 鼠标移入时瞬间变大 1.4 倍，对比强烈 */
    .icon_svg {
      opacity: 1;
      filter: grayscale(0);
      transform: scale(1.1);
      color: var(--brand-color-pure) !important; /* 激活品牌色，凸显辅助功能 */
    }
    .hint_tooltip {
      opacity: 0.6; /* Hover 时增加亮度，但仍保持柔和 */
      filter: grayscale(0); /* 恢复颜色（如果有的话） */
    }
    .hint_tooltip {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }

  .hint_tooltip {
    position: absolute;
    bottom: calc(100% + 12px);
    right: 0px; /* 改为右对齐，确保气泡内容向左伸展，不被侧边栏右边缘切断 */
    z-index: 1000;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s var(--transition-base);
    display: flex;
    flex-direction: column;
    align-items: flex-end; /* 使内容和箭头靠右排列，箭头对齐图标 */
    transform: translateY(10px);
    .tooltip_arrow {
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #000; /* 使用更纯粹的黑色以增强对比度 */
      margin-top: -1px;
      margin-right: 4px; /* 仍然对齐图标中心 */
    }

    .tooltip_content {
      background: #000; /* 直接使用黑色背景，去除透明度和模糊以保证文字绝对清晰 */
      color: #fff;
      padding: 8px 12px;
      border-radius: var(--radius-s);
      font-size: 12px;
      font-weight: 600; /* 加粗字体增强可读性 */
      line-height: 1.2;
      white-space: nowrap;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* 减小阴影扩散，使其更锐利 */
    }
  }

  /* 动画效果 - 移除 Vue Transition，改用 CSS 过渡以匹配整体风格 */
}
</style>
